module.exports = __webpack_public_path__ + "static/media/background_home.b3dafbe8.png";